import { styled, css, Box, InputBase } from '@mui/material'
import getPaletteColor from '../../../utils/getPaletteColor'
import IconButton from '../IconButton'

export const ReadOnlyLabel = styled('span')(
  () => css`
    width: 100%;
    min-width: 50px;
    margin: 0 auto;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  `
)

export const CounterWrapper = styled(Box)(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px;
    gap: 6px;
    border-radius: 10px;
    background-color: ${theme.palette.grey[100]};
  `
)

export const CounterInput = styled(InputBase)(
  () => css`
    input {
      min-width: 32px;
      height: 24px;
      text-align: center;
      box-sizing: border-box;
      padding: 4px;
      border: 0;
      background: none;
      appearance: none;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        appearance: none;
      }

      &:read-only {
        cursor: default;
      }
    }
  `
)

export const CounterButton = styled(IconButton)(
  ({ color, theme }) => css`
    border-radius: 6px;
    width: 24px;
    height: 24px;
    font-size: 18px;
    background: ${getPaletteColor(theme, color)};
    color: ${getPaletteColor(theme, color, 'contrastText')};
    padding: 4px;

    &:hover {
      background: ${getPaletteColor(theme, color, 'light')};
    }

    &.disabled {
      cursor: default;
      background: ${getPaletteColor(theme, color)};
      opacity: 0.15;
    }
  `
)
CounterButton.defaultProps = {
  color: 'default'
}

export const SideCounterWrapper = styled(Box)(
  () => css`
    position: relative;
  `
)

export const SideCounter = styled(CounterButton)(
  () => css`
    border-radius: 48px;
    position: absolute;
    bottom: 0;
    right: 0;
  `
)
